import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'
const getTranslateMasterFilters = function () {
  return {
    cif: { label: i18n.t('companies.cif').toLowerCase(), value: '' },
    name: { label: i18n.t('companies.companyName'), value: '' },
    send_alerts: { label: i18n.t('app.send_alerts'), value: '' },
    fechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '', type: 'date' },
    fechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '', type: 'date' },
    estado: { label: i18n.t('app.active'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' }
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'selected', width: '50px', headerSelectionValue: false, locked: true, lockable: false, columnMenu: false, reorderable: false, groupable: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      },
    },
    {
      field: 'Cliente',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      width: '150px',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'CIF', title: i18n.t('companies.cif'), columnMenu: 'myTemplate', width: '150px', locked: false },
    { field: 'RazonSocial', title: i18n.t('persons_data.nombre_completo'), columnMenu: 'myTemplate', width: '200px', locked: false },
    {
      field: 'Activo',
      title: i18n.t('app.active'),
      hidden: false,
      columnMenu: 'myTemplate',
      width: '100px',
      locked: false,
      cell: 'checkboxTemplate',
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active') } 
    },
    // { field: 'EmailAvisoNueva', title: i18n.t('companies.email_alerts'), columnMenu: 'myTemplate', width: '275px', locked: false },
    { field: 'FechaAlta', title: i18n.t('app.created_at'), type: 'date', filter: 'date', format: 'numeric_datetime', cell: 'fechaTemplate', columnMenu: 'myTemplate', width: '155px', locked: false, extraparams: { separators: { date: '-', datetime: ' ' } } },
    { field: 'EnviarAvisos', width: '150px', title: i18n.t('app.send_alerts'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'EmailAvisoNuevaEmitida', title: i18n.t('companies.email_nueva_emitida'), hidden: false, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailAvisoNuevaRecibida', title: i18n.t('companies.email_nueva_recibida'), hidden: false, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailAvisoCambioEstado', title: i18n.t('companies.email_cambio_estado'), hidden: false, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailTecnico', title: i18n.t('companies.email_tech'), hidden: false, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'Direccion', title: i18n.t('address.location'), hidden: true, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'CodigoPostal', title: i18n.t('address.codigo_postal'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
    { field: 'Poblacion', title: i18n.t('address.poblacion'), hidden: true, columnMenu: 'myTemplate', width: '250px', locked: false },
    { field: 'Provincia', title: i18n.t('address.provincia'), hidden: true, columnMenu: 'myTemplate', width: '250px', locked: false },
    { field: 'CodigoPais', title: i18n.t('address.pais'), format: 'PAISES', cell: 'enumTemplate', hidden: true, columnMenu: 'myTemplate', width: '250px', locked: false },
    { field: 'Telefono', title: i18n.t('address.telefono'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
    { field: 'IdCIFEmpresa', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
    {
      field: 'idCliente',
      title: i18n.t('clients.id_client'),
      hidden: true,
      columnMenu: 'myTemplate',
      width: '150px',
      locked: false,
      only: {
        roles: [7, 8, 3],
      }, 
    }
  ] 
}
const mystore = parent({ navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
